var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-5", attrs: { flat: "", loading: _vm.loading } },
    [
      _c("v-card-text", { staticClass: "pa-0" }, [
        _c(
          "div",
          { staticClass: "panel-content px-4 py-4" },
          [
            _c(
              "div",
              { staticClass: "mb-4" },
              [
                _c("div", { staticClass: "d-flex align-center mb-2" }, [
                  _c("span", { staticClass: "font-weight-bold" }, [
                    _vm._v(_vm._s(_vm.$t("current-organization"))),
                  ]),
                ]),
                !_vm.currentOrgIntegrations.length && !_vm.loading
                  ? _c(
                      "v-alert",
                      { attrs: { type: "info", outlined: "", dense: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("no-current-erp-integration")) +
                            " "
                        ),
                      ]
                    )
                  : _vm.currentOrgIntegrations.length
                  ? _c(
                      "v-list",
                      { staticClass: "pa-0" },
                      _vm._l(
                        _vm.currentOrgIntegrations,
                        function (currentOrgIntegration) {
                          return _c(
                            "v-list-item",
                            {
                              key: currentOrgIntegration.id,
                              staticClass:
                                "integration-item current-org-integration mb-2",
                            },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-medium mr-2",
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                currentOrgIntegration
                                                  ?.organizationName["fr-FR"]
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            "x-small": "",
                                            color: "info",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("current")) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c("v-spacer"),
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: { "offset-y": "", left: "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            attrs: {
                                                              icon: "",
                                                              "x-small": "",
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              small: "",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-dots-vertical"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _c(
                                            "v-list",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-list-item",
                                                {
                                                  attrs: {
                                                    disabled: _vm.loading,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.openErpOrgIdDialog(
                                                        currentOrgIntegration
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-icon",
                                                    { staticClass: "mr-2" },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "primary",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "mdi-identifier"
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-list-item-title", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "edit-erp-organization-id"
                                                        )
                                                      )
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _vm.isAvancieType(
                                                currentOrgIntegration
                                              )
                                                ? _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.loading ||
                                                          _vm.syncingId !==
                                                            null,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.confirmSynchronize(
                                                            currentOrgIntegration
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-icon",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color: "info",
                                                              },
                                                            },
                                                            [_vm._v("mdi-sync")]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "synchronize"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _c(
                                                "v-list-item",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      _vm.loading ||
                                                      _vm.resettingId !==
                                                        null ||
                                                      _vm.disablingId !== null,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.confirmResetLastTransfer(
                                                        currentOrgIntegration
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-icon",
                                                    { staticClass: "mr-2" },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "warning",
                                                          },
                                                        },
                                                        [_vm._v("mdi-history")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c("v-list-item-title", [
                                                    _vm._v(
                                                      _vm._s(_vm.$t("reset")) +
                                                        " lastTransfer"
                                                    ),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              currentOrgIntegration.enabled
                                                ? _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.loading ||
                                                          _vm.resettingId !==
                                                            null ||
                                                          _vm.disablingId !==
                                                            null,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.confirmDisableIntegration(
                                                            currentOrgIntegration
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-icon",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color: "error",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-power"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "disable-integration"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  )
                                                : _c(
                                                    "v-list-item",
                                                    {
                                                      attrs: {
                                                        disabled:
                                                          _vm.loading ||
                                                          _vm.resettingId !==
                                                            null ||
                                                          _vm.disablingId !==
                                                            null,
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.confirmEnableIntegration(
                                                            currentOrgIntegration
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "v-list-item-icon",
                                                        { staticClass: "mr-2" },
                                                        [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                small: "",
                                                                color:
                                                                  "success",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-power"
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                      _c("v-list-item-title", [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$t(
                                                              "enable-integration"
                                                            )
                                                          )
                                                        ),
                                                      ]),
                                                    ],
                                                    1
                                                  ),
                                              _c("v-divider"),
                                              _c(
                                                "v-list-item",
                                                {
                                                  attrs: {
                                                    disabled:
                                                      _vm.loading ||
                                                      _vm.resettingId !==
                                                        null ||
                                                      _vm.disablingId !==
                                                        null ||
                                                      _vm.syncingId !== null ||
                                                      _vm.savingErpOrgId,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.confirmRemoveErpIntegration(
                                                        currentOrgIntegration
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-list-item-icon",
                                                    { staticClass: "mr-2" },
                                                    [
                                                      _c(
                                                        "v-icon",
                                                        {
                                                          attrs: {
                                                            small: "",
                                                            color: "error",
                                                          },
                                                        },
                                                        [_vm._v("mdi-delete")]
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                  _c(
                                                    "v-list-item-title",
                                                    {
                                                      staticClass:
                                                        "error--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "remove-erp-integration"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "d-flex align-center" },
                                    [
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            color: currentOrgIntegration.enabled
                                              ? "primary"
                                              : "error",
                                            "x-small": "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                currentOrgIntegration.enabled
                                                  ? _vm.$t("enabled")
                                                  : _vm.$t("disabled")
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "v-chip",
                                        {
                                          staticClass: "mr-2",
                                          attrs: {
                                            color: "secondary",
                                            "x-small": "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                currentOrgIntegration.erpLabel ||
                                                  currentOrgIntegration.erpType
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "mt-1" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "d-flex flex-column" },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-caption grey--text",
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("organization-id")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    currentOrgIntegration.organizationId
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-caption grey--text",
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("erp-integration-id")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    currentOrgIntegration.id
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "v-icon",
                                                {
                                                  staticClass: "ml-1 copy-icon",
                                                  attrs: { small: "" },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.copyToClipboard(
                                                        currentOrgIntegration.id
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("mdi-content-copy")]
                                              ),
                                            ],
                                            1
                                          ),
                                          currentOrgIntegration.erpOrganizationId
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text-caption grey--text",
                                                },
                                                [
                                                  _c("strong", [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$t(
                                                          "erp-organization-id"
                                                        )
                                                      ) + ":"
                                                    ),
                                                  ]),
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(
                                                        currentOrgIntegration.erpOrganizationId
                                                      ) +
                                                      " "
                                                  ),
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "ml-1 copy-icon",
                                                      attrs: { small: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.copyToClipboard(
                                                            currentOrgIntegration.erpOrganizationId
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("mdi-content-copy")]
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-caption grey--text",
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t("last-transfer")
                                                  ) + ":"
                                                ),
                                              ]),
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    currentOrgIntegration.lastTransfer
                                                      ? _vm.formatDate(
                                                          currentOrgIntegration.lastTransfer
                                                        )
                                                      : _vm.$t("never")
                                                  ) +
                                                  " "
                                              ),
                                              _vm.isTransferStale(
                                                currentOrgIntegration.lastTransfer
                                              )
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass: "ml-1",
                                                      attrs: {
                                                        small: "",
                                                        color: "warning",
                                                      },
                                                    },
                                                    [_vm._v("mdi-alert")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "text-caption grey--text d-flex align-center",
                                            },
                                            [
                                              _c("strong", [
                                                _vm._v(
                                                  _vm._s(_vm.$t("query")) + ":"
                                                ),
                                              ]),
                                              _c(
                                                "v-btn",
                                                {
                                                  staticClass: "ml-1",
                                                  attrs: {
                                                    icon: "",
                                                    "x-small": "",
                                                    loading:
                                                      _vm.queryLoadingId ===
                                                      currentOrgIntegration.id,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      $event.stopPropagation()
                                                      return _vm.toggleQuery(
                                                        currentOrgIntegration
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "v-icon",
                                                    {
                                                      attrs: {
                                                        small: "",
                                                        color: "primary",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.expandedQueryId ===
                                                              currentOrgIntegration.id
                                                              ? "mdi-eye-off"
                                                              : "mdi-eye"
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm.expandedQueryId ===
                                              currentOrgIntegration.id
                                                ? _c(
                                                    "v-icon",
                                                    {
                                                      staticClass:
                                                        "ml-1 copy-icon",
                                                      attrs: { small: "" },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          $event.stopPropagation()
                                                          return _vm.copyToClipboard(
                                                            _vm
                                                              .integrationQueries[
                                                              currentOrgIntegration
                                                                .id
                                                            ]?.query || ""
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("mdi-content-copy")]
                                                  )
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm.expandedQueryId ===
                                  currentOrgIntegration.id
                                    ? _c(
                                        "div",
                                        { staticClass: "query-section mt-2" },
                                        [
                                          _c(
                                            "pre",
                                            {
                                              staticClass:
                                                "query-content text-caption",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.formatQuery(
                                                    _vm.integrationQueries[
                                                      currentOrgIntegration.id
                                                    ]?.query
                                                  )
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        }
                      ),
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _c("v-divider", { staticClass: "mb-4" }),
            _c(
              "div",
              [
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex align-center mb-2 other-integrations-header",
                    on: { click: _vm.toggleOtherIntegrations },
                  },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "mr-2", attrs: { small: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.showOtherIntegrations
                                ? "mdi-chevron-down"
                                : "mdi-chevron-right"
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c("span", { staticClass: "font-weight-bold" }, [
                      _vm._v(_vm._s(_vm.$t("other-erp-integrations"))),
                    ]),
                    _c(
                      "v-chip",
                      {
                        staticClass: "ml-2",
                        attrs: { "x-small": "", color: "grey lighten-2" },
                      },
                      [_vm._v(" " + _vm._s(_vm.otherIntegrations.length) + " ")]
                    ),
                    _vm.loadingOtherIntegrations
                      ? _c("v-progress-circular", {
                          staticClass: "ml-2",
                          attrs: { indeterminate: "", size: "16", width: "2" },
                        })
                      : _vm._e(),
                    _c("v-spacer"),
                    _vm.showOtherIntegrations &&
                    _vm.otherIntegrations.length > 0
                      ? [
                          _c(
                            "span",
                            { staticClass: "text-caption grey--text mr-2" },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.filteredOtherIntegrations.length) +
                                  " / " +
                                  _vm._s(_vm.otherIntegrations.length) +
                                  " "
                              ),
                            ]
                          ),
                          _vm.showOnlyStale
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    small: "",
                                    close: "",
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    "click:close": function ($event) {
                                      _vm.showOnlyStale = false
                                    },
                                  },
                                },
                                [_vm._v(" 7+ " + _vm._s(_vm.$t("days")) + " ")]
                              )
                            : _vm._e(),
                          _vm.showOnlyDisabled
                            ? _c(
                                "v-chip",
                                {
                                  staticClass: "mr-2",
                                  attrs: {
                                    small: "",
                                    close: "",
                                    color: "primary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                    },
                                    "click:close": function ($event) {
                                      _vm.showOnlyDisabled = false
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("disabled")) + " ")]
                              )
                            : _vm._e(),
                          _vm._l(_vm.selectedErpTypes, function (erpType) {
                            return _c(
                              "v-chip",
                              {
                                key: erpType,
                                staticClass: "mr-2 text-capitalize",
                                attrs: {
                                  small: "",
                                  close: "",
                                  color: "primary",
                                },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                  },
                                  "click:close": function ($event) {
                                    return _vm.toggleErpType(erpType)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(erpType) + " ")]
                            )
                          }),
                          _c(
                            "v-menu",
                            {
                              attrs: {
                                "offset-y": "",
                                "close-on-content-click": false,
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "activator",
                                    fn: function ({ on, attrs }) {
                                      return [
                                        _c(
                                          "v-badge",
                                          {
                                            attrs: {
                                              value: _vm.activeFilterCount > 0,
                                              content: _vm.activeFilterCount,
                                              color: "primary",
                                              overlap: "",
                                            },
                                          },
                                          [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      icon: "",
                                                      small: "",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                      },
                                                    },
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("v-icon", [
                                                  _vm._v("mdi-filter"),
                                                ]),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                false,
                                3714908966
                              ),
                            },
                            [
                              _c(
                                "v-list",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.showOnlyStale = !_vm.showOnlyStale
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-action",
                                        { staticClass: "mr-2" },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "hide-details": "",
                                              dense: "",
                                            },
                                            model: {
                                              value: _vm.showOnlyStale,
                                              callback: function ($$v) {
                                                _vm.showOnlyStale = $$v
                                              },
                                              expression: "showOnlyStale",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("filter-stale-transfers")
                                          )
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-list-item",
                                    {
                                      on: {
                                        click: function ($event) {
                                          _vm.showOnlyDisabled =
                                            !_vm.showOnlyDisabled
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "v-list-item-action",
                                        { staticClass: "mr-2" },
                                        [
                                          _c("v-checkbox", {
                                            attrs: {
                                              "hide-details": "",
                                              dense: "",
                                            },
                                            model: {
                                              value: _vm.showOnlyDisabled,
                                              callback: function ($$v) {
                                                _vm.showOnlyDisabled = $$v
                                              },
                                              expression: "showOnlyDisabled",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c("v-list-item-title", [
                                        _vm._v(
                                          _vm._s(_vm.$t("filter-disabled"))
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                  _c("v-divider", { staticClass: "my-1" }),
                                  _c("v-subheader", [
                                    _vm._v(_vm._s(_vm.$t("erp-type"))),
                                  ]),
                                  _vm._l(_vm.erpTypes, function (erpType) {
                                    return _c(
                                      "v-list-item",
                                      {
                                        key: erpType,
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleErpType(erpType)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "v-list-item-action",
                                          { staticClass: "mr-2" },
                                          [
                                            _c("v-checkbox", {
                                              attrs: {
                                                "input-value":
                                                  _vm.selectedErpTypes.includes(
                                                    erpType
                                                  ),
                                                "hide-details": "",
                                                dense: "",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "text-capitalize" },
                                          [_vm._v(" " + _vm._s(erpType) + " ")]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _vm.showOtherIntegrations
                  ? [
                      !_vm.filteredOtherIntegrations.length &&
                      !_vm.loadingOtherIntegrations
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mb-4",
                              attrs: { type: "info", outlined: "", dense: "" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("no-erp-integrations-found")) +
                                  " "
                              ),
                            ]
                          )
                        : _c(
                            "v-list",
                            { staticClass: "pa-0" },
                            _vm._l(
                              _vm.filteredOtherIntegrations,
                              function (integration, index) {
                                return _c(
                                  "div",
                                  { key: `${integration.id}-${index}` },
                                  [
                                    _c(
                                      "v-list-item",
                                      { staticClass: "integration-item mb-2" },
                                      [
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "font-weight-medium mr-2",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          integration
                                                            ?.organizationName[
                                                            "fr-FR"
                                                          ]
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c("v-spacer"),
                                                _c(
                                                  "v-menu",
                                                  {
                                                    attrs: {
                                                      "offset-y": "",
                                                      left: "",
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "activator",
                                                          fn: function ({
                                                            on,
                                                            attrs,
                                                          }) {
                                                            return [
                                                              _c(
                                                                "v-btn",
                                                                _vm._g(
                                                                  _vm._b(
                                                                    {
                                                                      attrs: {
                                                                        icon: "",
                                                                        "x-small":
                                                                          "",
                                                                      },
                                                                    },
                                                                    "v-btn",
                                                                    attrs,
                                                                    false
                                                                  ),
                                                                  on
                                                                ),
                                                                [
                                                                  _c(
                                                                    "v-icon",
                                                                    {
                                                                      attrs: {
                                                                        small:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "mdi-dots-vertical"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  },
                                                  [
                                                    _c(
                                                      "v-list",
                                                      { attrs: { dense: "" } },
                                                      [
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm.loading ||
                                                                _vm.resettingId !==
                                                                  null ||
                                                                _vm.disablingId !==
                                                                  null,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.openErpOrgIdDialog(
                                                                  integration
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-icon",
                                                              {
                                                                staticClass:
                                                                  "mr-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "secondary",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-identifier"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "edit-erp-organization-id"
                                                                    )
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "v-list-item",
                                                          {
                                                            attrs: {
                                                              disabled:
                                                                _vm.loading ||
                                                                _vm.resettingId !==
                                                                  null ||
                                                                _vm.disablingId !==
                                                                  null,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.confirmResetLastTransfer(
                                                                  integration
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-list-item-icon",
                                                              {
                                                                staticClass:
                                                                  "mr-2",
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                      color:
                                                                        "warning",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "mdi-history"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "v-list-item-title",
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "reset"
                                                                    )
                                                                  ) +
                                                                    " lastTransfer"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        integration.enabled
                                                          ? _c(
                                                              "v-list-item",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.loading ||
                                                                    _vm.resettingId !==
                                                                      null ||
                                                                    _vm.disablingId !==
                                                                      null,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.confirmDisableIntegration(
                                                                        integration
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          color:
                                                                            "error",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-power"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "disable-integration"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            )
                                                          : _c(
                                                              "v-list-item",
                                                              {
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.loading ||
                                                                    _vm.resettingId !==
                                                                      null ||
                                                                    _vm.disablingId !==
                                                                      null,
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.confirmEnableIntegration(
                                                                        integration
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-list-item-icon",
                                                                  {
                                                                    staticClass:
                                                                      "mr-2",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "v-icon",
                                                                      {
                                                                        attrs: {
                                                                          small:
                                                                            "",
                                                                          color:
                                                                            "success",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "mdi-power"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                                _c(
                                                                  "v-list-item-title",
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.$t(
                                                                          "enable-integration"
                                                                        )
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-title",
                                              {
                                                staticClass:
                                                  "d-flex align-center",
                                              },
                                              [
                                                _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      color: integration.enabled
                                                        ? "primary"
                                                        : "error",
                                                      "x-small": "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          integration.enabled
                                                            ? _vm.$t("enabled")
                                                            : _vm.$t("disabled")
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                                _c(
                                                  "v-chip",
                                                  {
                                                    staticClass: "mr-2",
                                                    attrs: {
                                                      color: "secondary",
                                                      "x-small": "",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          integration.erpLabel ||
                                                            integration.erpType
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item-subtitle",
                                              { staticClass: "mt-1" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d-flex flex-column",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text",
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "organization-id"
                                                              )
                                                            ) + ":"
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              integration.organizationId
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text",
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "erp-integration-id"
                                                              )
                                                            ) + ":"
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              integration.id
                                                            ) +
                                                            " "
                                                        ),
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            staticClass:
                                                              "ml-1 copy-icon",
                                                            attrs: {
                                                              small: "",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.copyToClipboard(
                                                                  integration.id
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              "mdi-content-copy"
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    integration.erpOrganizationId
                                                      ? _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "text-caption grey--text",
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(
                                                                    "erp-organization-id"
                                                                  )
                                                                ) + ":"
                                                              ),
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  integration.erpOrganizationId
                                                                ) +
                                                                " "
                                                            ),
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "ml-1 copy-icon",
                                                                attrs: {
                                                                  small: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.copyToClipboard(
                                                                        integration.erpOrganizationId
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-content-copy"
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        )
                                                      : _vm._e(),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text",
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "last-transfer"
                                                              )
                                                            ) + ":"
                                                          ),
                                                        ]),
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              integration.lastTransfer
                                                                ? _vm.formatDate(
                                                                    integration.lastTransfer
                                                                  )
                                                                : _vm.$t(
                                                                    "never"
                                                                  )
                                                            ) +
                                                            " "
                                                        ),
                                                        _vm.isTransferStale(
                                                          integration.lastTransfer
                                                        )
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "ml-1",
                                                                attrs: {
                                                                  small: "",
                                                                  color:
                                                                    "warning",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-alert"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "text-caption grey--text d-flex align-center",
                                                      },
                                                      [
                                                        _c("strong", [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t("query")
                                                            ) + ":"
                                                          ),
                                                        ]),
                                                        _c(
                                                          "v-btn",
                                                          {
                                                            staticClass: "ml-1",
                                                            attrs: {
                                                              icon: "",
                                                              "x-small": "",
                                                              loading:
                                                                _vm.queryLoadingId ===
                                                                integration.id,
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                $event.stopPropagation()
                                                                return _vm.toggleQuery(
                                                                  integration
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "v-icon",
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  color:
                                                                    "primary",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      _vm.expandedQueryId ===
                                                                        integration.id
                                                                        ? "mdi-eye-off"
                                                                        : "mdi-eye"
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm.expandedQueryId ===
                                                        integration.id
                                                          ? _c(
                                                              "v-icon",
                                                              {
                                                                staticClass:
                                                                  "ml-1 copy-icon",
                                                                attrs: {
                                                                  small: "",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.copyToClipboard(
                                                                        _vm
                                                                          .integrationQueries[
                                                                          integration
                                                                            .id
                                                                        ]
                                                                          ?.query ||
                                                                          ""
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "mdi-content-copy"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm.expandedQueryId ===
                                            integration.id
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "query-section mt-2",
                                                  },
                                                  [
                                                    _c(
                                                      "pre",
                                                      {
                                                        staticClass:
                                                          "query-content text-caption",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.formatQuery(
                                                              _vm
                                                                .integrationQueries[
                                                                integration.id
                                                              ]?.query
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("v-divider", { staticClass: "my-1" }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
          ],
          1
        ),
      ]),
      _c("confirmation-dialog", {
        ref: "dialogRef",
        attrs: { "content-class": "devops-subdialog" },
      }),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "500",
            persistent: "",
            "content-class": "devops-subdialog",
          },
          model: {
            value: _vm.erpOrgIdDialog,
            callback: function ($$v) {
              _vm.erpOrgIdDialog = $$v
            },
            expression: "erpOrgIdDialog",
          },
        },
        [
          _c(
            "v-card",
            { staticClass: "py-6 px-3" },
            [
              _c(
                "v-card-title",
                { staticClass: "text-h6 font-weight-bold py-0 px-4" },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("edit-erp-organization-id")) + " "
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.closeErpOrgIdDialog },
                    },
                    [_c("v-icon", [_vm._v("mdi-close")])],
                    1
                  ),
                ],
                1
              ),
              _c("v-divider", { staticClass: "my-4 mx-4" }),
              _c(
                "v-card-text",
                { staticClass: "pb-2" },
                [
                  _c("v-text-field", {
                    attrs: {
                      label: _vm.$t("erp-organization-id"),
                      outlined: "",
                      dense: "",
                      "hide-details": "",
                    },
                    model: {
                      value: _vm.erpOrgIdValue,
                      callback: function ($$v) {
                        _vm.erpOrgIdValue = $$v
                      },
                      expression: "erpOrgIdValue",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                { staticClass: "px-4 pt-4 pb-2 d-flex justify-space-between" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: { color: "error", disabled: _vm.savingErpOrgId },
                      on: { click: _vm.closeErpOrgIdDialog },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "px-4",
                      attrs: {
                        color: "primary",
                        loading: _vm.savingErpOrgId,
                        disabled: _vm.savingErpOrgId,
                      },
                      on: { click: _vm.saveErpOrgId },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("save")) + " ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }